import React from "react"

import {
  futuresOrdersPlatformDisplayName,
  normalizeFuturesOrdersCsvBrokerSlug,
} from "../../utils/futuresOrdersCsvBroker"
import BrokerGuidancePanel from "./BrokerGuidancePanel"
import {
  ChecklistRow,
  GuidanceAccordionBody,
  GuidanceBlock,
  GuidanceIntro,
} from "./ibkrGuidanceShared"

export interface FuturesOrdersCsvImportGuidanceProps {
  brokerName: string
  compact?: boolean
}

const ORDERS_EXPORT_STEPS: Record<string, { openReports: string; ordersTab: string }> = {
  tradovate: {
    openReports: "Open Reports from the main menu (or your account menu → Account reports).",
    ordersTab: "Select the Orders tab, not Performance.",
  },
  ninjatrader: {
    openReports:
      "Open your account performance or order history reports from the NinjaTrader account menu.",
    ordersTab: "Export the orders list as CSV (not a performance summary export).",
  },
}

const FuturesOrdersCsvImportGuidance = ({
  brokerName,
  compact = false,
}: FuturesOrdersCsvImportGuidanceProps): React.ReactElement => {
  const slug = normalizeFuturesOrdersCsvBrokerSlug(brokerName)
  const platform = futuresOrdersPlatformDisplayName(brokerName)
  const steps = slug ? ORDERS_EXPORT_STEPS[slug] : null

  return (
    <BrokerGuidancePanel
      title={`How to export orders from ${platform}`}
      compact={compact}
      collapsible
    >
      <GuidanceAccordionBody>
        <GuidanceIntro className="!mb-0">
          Download the Orders report as CSV, then upload it here.
        </GuidanceIntro>

        {steps ? (
          <GuidanceBlock title={`In ${platform}`}>
            <ChecklistRow className="!mb-0">{steps.openReports}</ChecklistRow>
            <ChecklistRow className="!mb-0">{steps.ordersTab}</ChecklistRow>
            <ChecklistRow className="!mb-0">
              Set your date range, run the report, then download CSV.
            </ChecklistRow>
          </GuidanceBlock>
        ) : null}

        <GuidanceBlock title="Fees (optional)">
          <ChecklistRow className="!mb-0">
            Export Cash History for the same accounts and date range as Orders.
          </ChecklistRow>
          <ChecklistRow className="!mb-0">
            Download CSV and attach it below as Cash History.
          </ChecklistRow>
        </GuidanceBlock>

        <GuidanceBlock title="Timezone">
          <ChecklistRow className="!mb-0">
            For Fill Time timezone, pick the IANA zone that matches the times shown in the CSV.
          </ChecklistRow>
        </GuidanceBlock>
      </GuidanceAccordionBody>
    </BrokerGuidancePanel>
  )
}

export default FuturesOrdersCsvImportGuidance
